import { Route } from '@angular/router';
import { subscriptionAccessGuard } from '@rma/dashboard/billing/subscription-plans/public/api-subscription-features';
import { logRedirectGuard, RmaEmptyComponent } from '@rma/dashboard/generic/util/router-utils';
import { externalProviderGuard } from '@rma/dashboard/reviews/private/api-external-provider-status';

export const reviewRoutes: Route[] = [
  {
    path: '',
    loadChildren: () => import('@rma/dashboard/reviews/manager'),
  },
  {
    path: 'upgrade',
    loadChildren: () => import('@rma/dashboard/reviews/upgrade-landers'),
  },
  {
    path: 'request',
    title: 'Request | Reviews',
    loadChildren: () => import('@rma/dashboard/reviews/review-request'),
  },
  {
    path: 'completed',
    title: 'Completed | Reviews',
    children: [
      {
        path: ':reviewCode/received',
        loadComponent: () => import('@rma/dashboard/reviews/received'),
      },
    ],
  },
  {
    path: 'import',
    title: 'Import | Reviews',
    canActivate: [subscriptionAccessGuard('HasImportReviews', '/reviews/upgrade')],
    children: [
      {
        path: '',
        canActivate: [externalProviderGuard],
        component: RmaEmptyComponent,
      },
      {
        path: 'existing',
        loadChildren: () => import('@rma/dashboard/reviews/add-existing'),
      },
      {
        path: 'external',
        loadChildren: () => import('@rma/dashboard/reviews/link-external'),
      },
    ],
  },
  // Remove after 2024-06-30
  {
    path: 'easy-reviews',
    canActivate: [logRedirectGuard('/settings/easy-reviews')],
    component: RmaEmptyComponent,
  },
];
